var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"map"},[_c('l-map',{ref:"map",attrs:{"zoom":_vm.zoom,"center":_vm.center},on:{"ready":function($event){return _vm.onMapReady()}}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }